import { useState, useEffect } from 'react'
import { supabaseHelpers } from '../lib/supabase'

export const useAuth = () => {
  const [user, setUser] = useState(null)
  const [userProfile, setUserProfile] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Check for stored user on app start
    const checkStoredUser = () => {
      console.log('Checking for stored user...');
      
      const storedUser = localStorage.getItem('homeScoutUser')
      if (storedUser) {
        try {
          const userData = JSON.parse(storedUser)
          console.log('Found stored user:', userData);
          
          setUser(userData)
          setUserProfile(userData)
        } catch (error) {
          console.error('Error parsing stored user:', error)
          localStorage.removeItem('homeScoutUser')
        }
      } else {
        console.log('No stored user found');
      }
      setLoading(false)
    }

    checkStoredUser()
  }, [])

  const signUp = async (email, password, userData) => {
    setLoading(true)
    console.log('SignUp attempt:', { email, userData });
    
    try {
      const { data, error } = await supabaseHelpers.signUp(email, password, userData)
      
      console.log('SignUp result:', { data, error });
      
      if (!error && data.user) {
        console.log('SignUp successful, setting user:', data.user);
        
        setUser(data.user)
        setUserProfile(data.user)
        localStorage.setItem('homeScoutUser', JSON.stringify(data.user))
      }

      setLoading(false)
      return { data, error }
    } catch (err) {
      console.error('SignUp error:', err);
      setLoading(false)
      return { data: null, error: err }
    }
  }

  const signIn = async (email, password) => {
    setLoading(true)
    console.log('SignIn attempt:', email);
    
    try {
      const { data, error } = await supabaseHelpers.signIn(email, password)
      
      console.log('SignIn result:', { data, error });
      
      if (!error && data.user) {
        console.log('SignIn successful, setting user:', data.user);
        
        setUser(data.user)
        setUserProfile(data.user)
        localStorage.setItem('homeScoutUser', JSON.stringify(data.user))
      }

      setLoading(false)
      return { data, error }
    } catch (err) {
      console.error('SignIn error:', err);
      setLoading(false)
      return { data: null, error: err }
    }
  }

  const signOut = async () => {
    setLoading(true)
    console.log('SignOut initiated');
    
    try {
      const { error } = await supabaseHelpers.signOut()
      
      setUser(null)
      setUserProfile(null)
      localStorage.removeItem('homeScoutUser')
      
      console.log('SignOut completed');
      setLoading(false)
      return { error }
    } catch (err) {
      console.error('SignOut error:', err);
      setLoading(false)
      return { error: err }
    }
  }

  return {
    user,
    userProfile,
    loading,
    signUp,
    signIn,
    signOut
  }
}